import { BotType } from "@rosette/ts/src/business/game/BotType.js";
import easyIcon from "@rosette/assets/src/buttons/mode_computer_easy.svg";
import mediumIcon from "@rosette/assets/src/buttons/mode_computer_medium.svg";
import hardIcon from "@rosette/assets/src/buttons/mode_computer_hard.svg";
import pandaIcon from "@rosette/assets/src/buttons/mode_computer_panda.svg";
import type { StaticImageData } from "next/image";


export function getBotIcon(botType: BotType): StaticImageData {
    if (botType === BotType.EASY)
        return easyIcon;
    if (botType === BotType.MEDIUM)
        return mediumIcon;
    if (botType === BotType.HARD)
        return hardIcon;
    if (botType === BotType.PANDA)
        return pandaIcon;

    throw new Error("Unknown bot type, " + botType.getID());
}
